import {Folder} from '../../../Assets.types';

/**
 * Immutably update a folder in the tree
 * @param assetTree - The tree structure
 * @param folderId - ID of the folder to update
 * @param updates - Partial folder updates
 * @returns New tree with updated folder
 */
export default function updateFolderInTree(
  assetTree: Folder | null,
  folderId: number,
  updates: Partial<Folder>,
): Folder | null {
  if (!assetTree) {
    return null;
  }

  function updateFolder(folder: Folder): Folder {
    if (folder.folderId === folderId) {
      return {
        ...folder,
        ...updates,
        folders: updates.folders !== undefined ? updates.folders : folder.folders?.map(updateFolder),
        assets: updates.assets !== undefined ? updates.assets : folder.assets,
      };
    }

    return {
      ...folder,
      folders: folder.folders?.map(updateFolder),
    };
  }

  return updateFolder(assetTree);
}

